module.exports = __webpack_public_path__ + "static/media/simplexion-icon.c56f90c6.ico";